import { Link } from 'react-router-dom';
import { FaRobot, FaHome, FaEnvelope } from 'react-icons/fa';
import SEO from '../components/SEO';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const NotFound = () => {
  return (
    <>
      <SEO 
        title="404 - Page Not Found | ViralVoice AI"
        description="The page you're looking for doesn't exist"
      />
      <Navbar />
      <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white pt-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          {/* Error Card */}
          <div className="bg-gray-800/50 backdrop-blur-xl rounded-2xl p-8 border border-gray-700/50">
            {/* Hero Section */}
            <div className="flex flex-col md:flex-row items-center gap-8 mb-12">
              <div className="relative group w-64 h-64 flex-shrink-0">
                <div className="absolute inset-0 bg-gradient-to-br from-green-400/20 to-blue-500/20 rounded-xl"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="text-center">
                    <span className="text-9xl font-bold bg-gradient-to-r from-green-400 to-blue-500 bg-clip-text text-transparent">
                      404
                    </span>
                    <div className="text-gray-400 mt-2">Page Not Found</div>
                  </div>
                </div>
                <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl flex items-center justify-center">
                  <FaRobot className="w-16 h-16 text-blue-400" />
                </div>
              </div>
              
              {/* Content */}
              <div className="text-center md:text-left">
                <h1 className="text-4xl font-bold mb-4">Oops! Lost in the AI Space</h1>
                <p className="text-gray-400 text-lg mb-6">
                  The page you're looking for seems to have wandered off. Let's get you back on track!
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <Link 
                    to="/"
                    className="inline-flex items-center px-6 py-3 rounded-full bg-gradient-to-r from-green-400 to-blue-500 hover:from-green-500 hover:to-blue-600 text-black font-semibold transition-all duration-300 gap-2"
                  >
                    <FaHome className="w-5 h-5" />
                    Back to Homepage
                  </Link>
                  <a 
                    href="mailto:appifyo@gmail.com"
                    className="inline-flex items-center px-6 py-3 rounded-full bg-gray-700 hover:bg-gray-600 text-white font-semibold transition-all duration-300 gap-2"
                  >
                    <FaEnvelope className="w-5 h-5" />
                    Contact Support
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NotFound; 